import { ApplicationAccessType, CommunicationType } from 'domains/content/types';
import {
    VoiceCallFallback,
    VoiceCallRoot,
    VoiceContentInteraction,
    VoiceContentStateTypes,
    VoicemailInteraction,
} from './types';

export enum actionTypes {
    SET_NAME = 'SET_NAME',
    SET_VOICE_CALL_ROOT_MESSAGE = 'SET_VOICE_CALL_ROOT_MESSAGE',
    ADD_INTERACTION = 'ADD_INTERACTION',
    UPDATE_INTERACTION = 'UPDATE_INTERACTION',
    REMOVE_INTERACTION = 'REMOVE_INTERACTION',
    SET_VOICE_CONTENT_STATE = 'SET_VOICE_CONTENT_STATE',
    ADD_VOICEMAIL_MESSAGE = 'ADD_VOICEMAIL_MESSAGE',
    REMOVE_VOICEMAIL_MESSAGE = 'REMOVE_VOICEMAIL_MESSAGE',
    SET_WAIT_TIME = 'SET_WAIT_TIME',
    SET_REPEAT = 'SET_REPEAT',
    SET_TIMEOUT_MESSAGE = 'SET_TIMEOUT_MESSAGE',
    SET_INCORRECT_RESPONSE_MESSAGE = 'SET_INCORRECT_RESPONSE_MESSAGE',
    SET_COMMUNICATION_TYPE = 'SET_COMMUNICATION_TYPE',
    SET_APPLICATIONS_ACCESS = 'SET_APPLICATIONS_ACCESS',
}

// Actions
export const setName = (name: string) => ({ type: actionTypes.SET_NAME, name });

export const setVoiceCallRootMessage = (message: VoiceCallRoot['message']) => ({
    type: actionTypes.SET_VOICE_CALL_ROOT_MESSAGE,
    message,
});

export const addInteraction = () => ({ type: actionTypes.ADD_INTERACTION });

export const updateInteraction = (interaction: VoiceContentInteraction, index: number) => ({
    type: actionTypes.UPDATE_INTERACTION,
    parameters: {
        interaction,
        index,
    },
});

export const removeInteraction = (index: number) => ({
    type: actionTypes.REMOVE_INTERACTION,
    index,
});

export const setVoiceContentState = (voiceContentState: VoiceContentStateTypes) => ({
    type: actionTypes.SET_VOICE_CONTENT_STATE,
    voiceContentState,
});

export const addVoicemailMessage = (voicemail: VoicemailInteraction) => ({
    type: actionTypes.ADD_VOICEMAIL_MESSAGE,
    voicemail,
});

export const removeVoicemailMessage = () => ({
    type: actionTypes.REMOVE_VOICEMAIL_MESSAGE,
});

export const setWaitTime = (waitTime: VoiceCallFallback['waitTime']) => ({
    type: actionTypes.SET_WAIT_TIME,
    waitTime,
});

export const setRepeat = (repeat: VoiceCallFallback['repeat']) => ({
    type: actionTypes.SET_REPEAT,
    repeat,
});

export const setTimeoutMessage = (timeoutMessage: VoiceCallFallback['timeoutMessage']) => ({
    type: actionTypes.SET_TIMEOUT_MESSAGE,
    timeoutMessage,
});

export const setIncorrectResponseMessage = (
    incorrectResponseMessage: VoiceCallFallback['incorrectResponseMessage']
) => ({
    type: actionTypes.SET_INCORRECT_RESPONSE_MESSAGE,
    incorrectResponseMessage,
});

export const setCommunicationType = (communicationType: CommunicationType) => ({
    type: actionTypes.SET_COMMUNICATION_TYPE,
    communicationType,
});

export const setApplicationsAccess = (applicationsAccess: ApplicationAccessType[]) => ({
    type: actionTypes.SET_APPLICATIONS_ACCESS,
    applicationsAccess,
});
